// extracted by mini-css-extract-plugin
module.exports = {"tile":"HomeOpenOrdersSection_tile__iGKVD","cardButton":"HomeOpenOrdersSection_cardButton__1VfWG","overdueCard":"HomeOpenOrdersSection_overdueCard__3qAPS"};